import { TicketState } from 'types/api';

interface PendingUseTicketLike {
  status: TicketState | string;
  scheduleTerm?: { endedAt?: number } | null;
}

/*
  사용처리 누락 후보: 일정이 이미 끝났는데 티켓이 아직 예약확정으로 남은 것.
  주문 상태가 아니라 티켓 상태로 판단하므로, "일부 취소 + 나머지 사용" 처럼 실제로는 처리가 끝났는데
  주문 상태만 예약확정으로 남은 주문은 잡히지 않는다.
  일정이 없는 티켓(만료일 기준 상품)은 일정 종료로 판단할 수 없어 제외한다.
 */
export const isPendingUseTicket = (
  ticket: PendingUseTicketLike,
  now: number = Date.now(),
): boolean => {
  const endedAt = ticket.scheduleTerm?.endedAt;

  return ticket.status === TicketState.CONFIRMED && !!endedAt && endedAt < now;
};
